const LaisIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#49317A"
      />
      <path
        d="M12.1152 5.18813L13.3365 5.40222L12.9612 7.54285L13.7363 7.6784L14.2406 4.80331L12.2434 4.45312L12.1152 5.18813Z"
        fill="white"
      />
      <path
        d="M16.0896 9.84025L18.3252 7.96225L17.0215 6.41016L16.4504 6.89016L17.2476 7.83979L15.584 9.23807L16.0896 9.84025Z"
        fill="white"
      />
      <path
        d="M18.6777 12.2228H16.5049V13.0091H19.4233V10.9824H18.6777V12.2228Z"
        fill="white"
      />
      <path
        d="M16.9562 16.498L15.2926 15.1006L14.7861 15.7028L17.0217 17.5802L18.3253 16.0284L17.7542 15.5484L16.9562 16.498Z"
        fill="white"
      />
      <path
        d="M12.8896 18.6672L12.5143 16.5273L11.7397 16.6629L12.2432 19.538L14.2404 19.1883L14.1114 18.4531L12.8896 18.6672Z"
        fill="white"
      />
      <path
        d="M8.78625 15.4395L7.32471 17.9663L9.07916 18.9814L9.4528 18.335L8.37907 17.7145L9.4678 15.8333L8.78625 15.4395Z"
        fill="white"
      />
      <path
        d="M7.57862 13.3429L7.30999 12.6035L4.56689 13.6025L5.26044 15.507L5.96108 15.252L5.53699 14.0861L7.57862 13.3429Z"
        fill="white"
      />
      <path
        d="M5.69162 9.47901L7.73408 10.2219L8.00271 9.48256L5.26044 8.48438L4.56689 10.3888L5.2678 10.6441L5.69162 9.47901Z"
        fill="white"
      />
      <path
        d="M7.32471 6.02486L7.69834 6.6704L8.77207 6.0494L9.85998 7.9304L10.5407 7.53658L9.07916 5.00977L7.32471 6.02486Z"
        fill="white"
      />
    </svg>
  );
};
export default LaisIcon;
